import { SR_API_ACTION_UTILITY_RESET_PASSWORD } from 'api/utilityActionTypes';

import login from 'client/actions/UtilityAuth/login';

export default async function resetPasswordRequested({ state, utilityApiClient }, params) {
  const { token, password } = params;

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_RESET_PASSWORD,
    state: state,
    payload: {
      token,
      password,
    },
    onSuccess(user) {
      return login(
        { state, utilityApiClient },
        {
          phone: user.phone,
          password: password,
        },
      );
    },
  });
}
